import React, { Fragment } from "react";

const Home = () => {

    return (
        <Fragment>
            <h2>Home Page</h2>
        </Fragment>
    );
};

export default Home;